import React from 'react'
import { FlyOutStorefrontMetricsWrapper } from '../FlyOutStorefrontMetricsWrapper/FlyOutStorefrontMetricsWrapper'
import { faArrowPointer } from '@fortawesome/free-solid-svg-icons'
import { useStyles } from './GraphAndMap.styles'
import { ListingInteractions } from './ListingInteractions/ListingInteractions'
import { MetricsData } from '../../../modules/storefrontMetrics/reducer'
import { faFilterCircleDollar } from '@fortawesome/pro-duotone-svg-icons'
import CountriesMap from '../CountriesMap/CountriesMap'
export type TableAndConversionFunnelProps = {
  metricsData: MetricsData
}
export const GraphAndMap = () => {
  const { classes } = useStyles()
  return (
    <div className={classes.rootWrapper}>
      <div className={classes.root} data-testid="table-funnel-wrapper">
        <div className={classes.content}>
          <div className={classes.wrapperWidth} data-testid="table-wrapper">
            <FlyOutStorefrontMetricsWrapper
              children={<ListingInteractions />}
              heading="Listing interactions"
              icon={faArrowPointer}
              infoTooltip={'Listings interactions'}
              padding={'0px'}
            />
          </div>
        </div>
      </div>
      <div className={classes.root}>
        <div className={classes.content}>
          <div className={classes.wrapperWidth} data-testid="funnel-wrapper">
            <FlyOutStorefrontMetricsWrapper
              children={<CountriesMap />}
              heading="Geographical listing impressions"
              icon={faFilterCircleDollar}
              infoTooltip={'Geographical listings impressions'}
              padding={'0px'}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
